const SUPPORTED = new Set(['en','ja']);

function norm(v?: string|null): 'en'|'ja'|undefined {
  if (!v) return;
  const base = v.toLowerCase().split('-')[0];
  return SUPPORTED.has(base) ? (base as 'en'|'ja') : undefined;
}

function fromQuery() {
  const sp = new URLSearchParams(location.search);
  return norm(sp.get('lang'));
}
function fromStorage() {
  try { return norm(localStorage.getItem('lang')); } catch { return; }
}
function fromNavigatorList() {
  const list = Array.isArray(navigator.languages) && navigator.languages.length
    ? navigator.languages : [navigator.language];
  for (const l of list) {
    const n = norm(l);
    if (n) return n;
  }
}
export function decideInitialLang(): 'en'|'ja' {
  return fromQuery() ?? fromStorage() ?? fromNavigatorList() ?? 'en';
}
export function persistLang(lang: 'en'|'ja') {
  try { localStorage.setItem('lang', lang); } catch { /* ignore */ }
}
export function stripLangQuery() {
  const url = new URL(location.href);
  if (url.searchParams.has('lang')) {
    url.searchParams.delete('lang');
    history.replaceState({}, '', url.toString());
  }
}
